import type { FieldRegistryItem } from '../field-types'
import CollectionEntitySidebar from './collection/CollectionEntitySidebar.vue'
import CollectionField from './collection/CollectionField.vue'

export const collectionField: FieldRegistryItem<'collection'> = {
  field: CollectionField,
  entitySidebar: CollectionEntitySidebar,
}
